import React, { useState } from "react";
import { Card, CardBody, Table, Button, Spinner } from "reactstrap";
import numberToWords from "../../../../../Components/Common/numberToWords";
import InvoiceBillModal from "./InvoiceBillModal";
import { PrintBill } from "../../../BillPrint/page/PrintBill";
import toast from "react-hot-toast";
import SectionService from "../../../../../services/OrderingServices/SectionService";

const InvoiceSummary = ({
  orgInfo,
  user,
  selectedTable,
  orderId,
  items,
  calculateTotals,
  paymentStatus,
  selected,
  handleCheckout,
  handleSelect,
  promoSuccess,
  discountAmount,
  selectedPayment,
  selectedCustomer,
  selectedPayments,
  rawOrder,
  isValidAmount,
  userInfo,
  handleUnmergeTable,
  returnAmount,
  totalPaid,
}) => {
  console.log("🚀 ~ InvoiceSummary ~ items:", items);
  console.log("🚀 ~ InvoiceSummary ~ selectedPayments:", selectedPayments);
  console.log("🚀 ~ InvoiceSummary ~ orgInfo:", orgInfo);
  const [expandedItems, setExpandedItems] = useState({});
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const toggleChildren = (itemKey) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };

  return (
    <div className="sticky-column">
      <Card className="shadow-sm border-0 rounded-3">
        <CardBody
          className="d-flex flex-column p-3 text-level-3"
          style={{ fontFamily: "monospace" }}
        >
          {/* Header */}
          <PrintBill
            currentOrder={items}
            orgInfo={orgInfo}
            user={user}
            orderId={orderId}
            calculateTotals={calculateTotals}
            responseData={rawOrder}
            isestimateprint={true}
            selectedCustomer={selectedCustomer}
          />
          <div className="text-center mb-2">
            <h5 className="fw-bold text-uppercase mb-0 ">
              {userInfo?.categoryId === null
                ? orgInfo?.name
                : userInfo?.subOrgName}
            </h5>
            <div className="text-uppercase">{orgInfo?.address1 || ""}</div>
            <div>
              {userInfo?.categoryId === null
                ? orgInfo?.tel
                : userInfo?.subOrgPhone}
            </div>
            <div className="fw-bold mt-1 text-uppercase text-level-3">
              Provisional Invoice
            </div>
          </div>

          {/* Info Rows */}
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>PAN No.:</strong> {orgInfo?.panNumber || "...."}
            </div>
            <div>
              <strong>Copy of:</strong> Original
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>Customer:</strong>{" "}
              {selectedCustomer
                ? `${selectedCustomer.firstName} ${selectedCustomer.lastName}`
                : "...."}
            </div>
            <div>
              <strong>PAN:</strong> {"..."}
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>Phone No.:</strong> {selectedCustomer?.phoneNo || "...."}
            </div>
            <div>
              <strong>Cashier:</strong> {user?.name || "..."}
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>Address:</strong> {selectedCustomer?.address || "...."}
            </div>
            <div>
              <strong>INV No:</strong> {orderId || "..."}
            </div>
          </div>
          {/* <div className="d-flex justify-content-between small mb-2">
            <div>
              <strong>Date (B.S.):</strong> ...
            </div>
            <div>
              <strong>Date (A.D.):</strong>{" "}
              {new Date().toLocaleDateString("en-GB")}
            </div>
          </div> */}
          <div className="d-flex justify-content-between small mb-2">
            <div>
              <strong>Table:</strong> {selectedTable?.tableName || "T-1"}
            </div>
            <div>
              <strong>Time:</strong>{" "}
              {new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div>

          {/* Table */}
          <Table size="sm" responsive className="table-bordered small mb-0">
            <thead>
              <tr>
                <th>SN</th>
                <th>Item</th>
                <th className="text-center">Qty</th>
                <th className="text-center">Rate</th>
                <th className="text-end">Amnt</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => {
                const itemKey = `${item?.tableId}-${index}`;
                const isExpanded = expandedItems[itemKey];

                // ----- Complimentary Row -----
                const ComplimentaryRow =
                  item?.complimentaryQuantity > 0 ? (
                    <tr key={`${index}-comp`}>
                      <td>{index + 1}</td>

                      <td className="text-level-2">
                        <h6 className="fw-semibold mb-1 text-info">
                          {item.productName} (Complimentary)
                        </h6>

                        {/* Expandable attributes and children */}
                        <div
                          className="overflow-hidden"
                          style={{
                            maxHeight: isExpanded
                              ? `${item.children?.length * 50}px`
                              : "0px",
                            transition: "max-height 0.3s ease",
                          }}
                        >
                          {item?.children?.map((child, i) => (
                            <div key={i} className="mt-2">
                              <div className="d-flex justify-content-between">
                                <small>+ {child.productName}</small>
                                <small>{child.productPrice}</small>
                              </div>

                              {child?.attributes?.map((attr) => (
                                <small
                                  key={attr.id}
                                  className="text-muted d-block ms-2"
                                >
                                  - {attr.title}
                                </small>
                              ))}
                            </div>
                          ))}
                        </div>

                        <div
                          className="overflow-hidden"
                          style={{
                            maxHeight: isExpanded
                              ? `${item.attributes?.length * 50}px`
                              : "0px",
                            transition: "max-height 0.3s ease",
                          }}
                        >
                          {item?.attributes?.map((attr, i) => (
                            <div key={i} className="mt-2">
                              <div className="d-flex justify-content-between">
                                <small>+ {attr.title}</small>
                              </div>
                            </div>
                          ))}
                        </div>
                      </td>

                      {/* Qty */}
                      <td className="text-center text-primary">
                        {item.complimentaryQuantity}
                      </td>

                      {/* Rate = 0 */}
                      <td className="text-end text-primary">0.00</td>

                      {/* Amount = 0 */}
                      <td className="text-end text-primary">0.00</td>
                    </tr>
                  ) : null;

                // ----- Normal Row -----
                return (
                  <React.Fragment key={index}>
                    <tr>
                      <td>{index + 1}</td>

                      <td className="text-level-2">
                        <h6
                          className={`fw-semibold mb-1 ${
                            item?.children?.length > 0 ||
                            item?.attributes?.length > 0
                              ? "text-secondary cursor-pointer"
                              : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleChildren(itemKey);
                          }}
                        >
                          {item.productName}
                        </h6>

                        {/* Expandable Children */}
                        <div
                          className="overflow-hidden"
                          style={{
                            maxHeight: isExpanded
                              ? `${item.children?.length * 50}px`
                              : "0px",
                            transition: "max-height 0.3s ease",
                          }}
                        >
                          {item?.children?.map((childItem, i) => (
                            <div key={i} className="mt-2">
                              <div className="d-flex justify-content-between">
                                <small>+ {childItem.productName}</small>
                                <small>{childItem?.productPrice}</small>
                              </div>
                              {childItem?.attributes?.map((attr) => (
                                <small
                                  key={attr.id}
                                  className="text-muted d-block ms-2"
                                >
                                  - {attr.title}
                                </small>
                              ))}
                            </div>
                          ))}
                        </div>

                        {/* Expandable Attributes */}
                        <div
                          className="overflow-hidden"
                          style={{
                            maxHeight: isExpanded
                              ? `${item.attributes?.length * 50}px`
                              : "0px",
                            transition: "max-height 0.3s ease",
                          }}
                        >
                          {item?.attributes?.map((attr, i) => (
                            <div key={i} className="mt-2">
                              <div className="d-flex justify-content-between">
                                <small>+ {attr.title}</small>
                              </div>
                            </div>
                          ))}
                        </div>
                      </td>

                      {/* Quantity */}
                      <td className="text-center">{item.quantity}</td>

                      {/* Rate */}
                      <td className="text-end text-level-3">
                        {(() => {
                          const attrTotal = item?.attributes?.reduce(
                            (sum, a) => sum + (Number(a.value) || 0),
                            0
                          );
                          const childrenTotal = item?.children?.reduce(
                            (sum, c) => sum + (Number(c.productPrice) || 0),
                            0
                          );
                          const basePrice = Number(item?.productPrice) || 0;

                          const unitPrice =
                            attrTotal || childrenTotal
                              ? basePrice + attrTotal + childrenTotal
                              : basePrice;

                          return unitPrice.toFixed(2);
                        })()}
                      </td>

                      {/* Amount */}
                      <td className="text-end text-level-3">
                        {(() => {
                          const attrTotal = item?.attributes?.reduce(
                            (sum, a) => sum + (Number(a.value) || 0),
                            0
                          );
                          const childrenTotal = item?.children?.reduce(
                            (sum, c) => sum + (Number(c.productPrice) || 0),
                            0
                          );
                          const basePrice = Number(item?.productPrice) || 0;
                          const qty = Number(item?.quantity) || 0;

                          const unitPrice =
                            attrTotal || childrenTotal
                              ? basePrice + attrTotal + childrenTotal
                              : basePrice;

                          return (unitPrice * qty).toFixed(2);
                        })()}
                      </td>
                    </tr>

                    {/* Complimentary Row Inserted Here */}
                    {ComplimentaryRow}
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>

          {/* Totals */}
          <div className="border-top pt-2 small">
            <div className="d-flex justify-content-between">
              <div>Total Qty:</div>
              <div>
                {items.reduce(
                  (total, item) =>
                    total + item.quantity + (item.complimentaryQuantity || 0),
                  0
                )}
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <div>Sub Total:</div>
              <div>Rs. {calculateTotals.subTotal.toFixed(2)}</div>
            </div>
            {/* <div className="d-flex justify-content-between">
              <div>Discount Amount:</div>
              <div>-Rs {calculateTotals.discount.toFixed(2)}</div>
            </div> */}

            {(promoSuccess || discountAmount) && (
              <div className="d-flex justify-content-between">
                <div>Discount Amount:</div>
                <div>Rs {calculateTotals.discount.toFixed(2)}</div>
              </div>
            )}
            <div className="d-flex justify-content-between fw-bold">
              <div>Net Amount:</div>
              <div>Rs. {calculateTotals.total.toFixed(2)}</div>
            </div>
            <div className="mt-2">
              <div>
                <strong>In Words:</strong>{" "}
                {numberToWords(calculateTotals.total)}
              </div>
            </div>
            <div className="mt-2">
              {/* <div>
                Payment Mode: {selectedPayment?.name} (Rs{" "}
                {calculateTotals.total.toFixed(2)})
              </div> */}
              <div className="mt-2">
                <div>
                  Payment Mode:{" "}
                  {selectedPayments && selectedPayments.length > 0
                    ? selectedPayments.map((p) => p.name).join(", ")
                    : "Not selected"}
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div>Billed by: {user?.name || "Staff"}</div>
            </div>
          </div>

          {/* Footer Info */}
          <div className="small mt-2">
            <div className="text-center mt-2">**Thank You**</div>
            <div className="text-center text-muted small">
              Powered by Restro Order
            </div>
          </div>
        </CardBody>
      </Card>

      <div className="p-3 rounded-3 border-2 shadow-sm bg-white d-flex justify-content-between sticky-bottom align-items-center">
        <div>
          <p className="mb-0 text-muted small">Net sales amount</p>
          <h6 className="fw-bold mb-0 text-success">
            Rs {calculateTotals.total.toFixed(2)}
          </h6>
        </div>
        <Button
          color="success"
          className="px-4 shadow-sm"
          disabled={isConfirmLoading}
          onClick={async () => {
            // Prevent multiple clicks
            if (isConfirmLoading) {
              return;
            }

            if (!isValidAmount()) {
              toast.error(
                "Please enter valid payment amount(s) that match the total."
              );
              return;
            }


            setIsConfirmLoading(true);
            try {
              await handleCheckout();
            } finally {
              setIsConfirmLoading(false);
            }
          }}
        >
          {isConfirmLoading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Processing...
            </>
          ) : (
            "Confirm"
          )}
        </Button>
      </div>

      {/* <InvoiceBillModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        orgInfo={orgInfo}
        user={user}
        selectedTable={selectedTable}
        orderId={orderId}
        items={items}
        calculateTotals={calculateTotals}
        paymentStatus={paymentStatus}
        selected={selected}
      /> */}
    </div>
  );
};

export default InvoiceSummary;
